import { useMemo } from 'react';

import { InfoListCard } from 'ui';

import { ACCOUNT_CODE_FEATURES } from '../../../../utils';
import { AccountCodeFeatures, ProductItemProps } from './AssignAccountCodes.types';

const CAMPAIGN_TYPE_MAP = {
  campaign: 'Crowdfunding',
  athon: 'A-thon',
  rallyup: 'Fundraiser',
} as const;

type Props = {
  feature: AccountCodeFeatures;
  productItemProps?: ProductItemProps;
};

const AssignAccountCodeInfoBox = ({ feature, productItemProps }: Props) => {
  const featureDisplay = useMemo(() => {
    switch (feature) {
      case ACCOUNT_CODE_FEATURES.QUICK_PAY:
        return 'Quick Pay';
      case ACCOUNT_CODE_FEATURES.POS_DONATION:
        return 'POS Donations';
      case ACCOUNT_CODE_FEATURES.DONATION:
        return 'Direct Donations';
      case ACCOUNT_CODE_FEATURES.SHOP_TO_GIVE:
        return 'Rewards';
      case ACCOUNT_CODE_FEATURES.MEMBERSHIP:
      case ACCOUNT_CODE_FEATURES.CAMPAIGN:
      case ACCOUNT_CODE_FEATURES.PRODUCT:
      default:
        return 'Name:';
    }
  }, [feature]);

  return (
    <InfoListCard color="blue">
      <InfoListCard.Item label={featureDisplay} detail={productItemProps?.name} />
      {productItemProps?.category && (
        <InfoListCard.Item label="Category:" detail={productItemProps.category} />
      )}
      {productItemProps?.campaignType && (
        <InfoListCard.Item
          label="Campaign Type:"
          detail={CAMPAIGN_TYPE_MAP[productItemProps.campaignType] ?? productItemProps.campaignType}
        />
      )}
    </InfoListCard>
  );
};

export { AssignAccountCodeInfoBox };
